export class UserManageModel {
    productName: string;
}
